import { css } from '@emotion/core';
import { colors } from 'styles';

export const base = css`
  background: ${colors.white};
  box-shadow: 2px 4px 4px rgba(223, 223, 223, 0.25);
  border-radius: 4px;
`;
